{
  "bookmarkTitleLabel": "Marcadores",
  "debug": "Depuração",
  "devConnectionLabel": "Developer Connection",
  "exlSection": "Resultados da Experience League",
  "feedback": "Feedback",
  "fetchFailed": "Falha na busca",
  "help": "Ajuda",
  "helpDefaultFeatured": "Aprendizagem e suporte da Adobe Experience Cloud",
  "helpLoadError": "Algo deu errado. Tente novamente.",
  "noBookmarks": "Marque o conteúdo da ajuda como favorito para acessá-lo aqui",
  "noBookmarksTitle": "Sem marcadores",
  "noResults": "Nenhum resultado encontrado",
  "noResultsMessage": "Verifique a ortografia ou tente um termo de pesquisa diferente",
  "resourcesCustomerCareLabel": "Atendimento ao cliente",
  "resourcesStatusLabel": "Status",
  "support": "Suporte"
}
